import type { getTokenType } from "@dealer-center/core-components";
import type { VisibilityState } from "./store";
import type { useWindowDimensionsInterface } from "@dealer-center/core-custom-components";
import {
  footerHeight,
  headerHeight,
  navMenuWidth
} from "@dealer-center/core-custom-components";
import { shouldPinLinksMenu } from ".";

// Function to create component styles and test IDs
export function createComponents(getToken: getTokenType): Components {
  const maxPageWidth =
    Number(getToken("base.screen.3xl")?.replace("px", "")) || 1920; // Fallback to 1920 if undefined
  const components: Components = {
    pageTemplate: {
      style: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        height: "100%"
      },
      testId: "cc-page-template"
    },
    header: {
      style: {
        height: `${headerHeight}px`
      },
      testId: "cc-header"
    },
    content: {
      style: {
        display: "flex",
        flex: 1,
        overflow: "hidden"
      },
      testId: "cc-content"
    },
    leftSidebar: {
      style: {
        overflowY: "auto",
        width: `${navMenuWidth}px`,
        minWidth: `${navMenuWidth}px`,
        borderRight: `1px solid ${getToken("sem.color.shadow.default")}`
      },
      testId: "cc-left-sidebar"
    },
    rightContent: {
      style: {
        flex: 1,
        display: "flex"
      },
      testId: "cc-right-content"
    },
    page: {
      style: {
        flex: 1,
        overflowY: "auto"
      },
      testId: "cc-page"
    },
    pageContent: {
      style: {
        padding: "20px",
        height: `calc(100% - ${footerHeight}px)`,
        display: "table",
        margin: "0 auto",
        maxWidth: `${maxPageWidth}px`,
        width: "100%",
        boxSizing: "border-box"
      },
      testId: "cc-page-content"
    },
    footerSection: {
      style: {
        height: `${footerHeight}px !important`
      },
      testId: "cc-footer-section"
    }
  };
  return components;
}
type componentNames =
  | "pageTemplate"
  | "header"
  | "content"
  | "leftSidebar"
  | "rightContent"
  | "page"
  | "pageContent"
  | "footerSection";

type Components = Record<
  componentNames,
  {
    style: React.CSSProperties;
    testId: string;
  }
>;
export function hasAnyVisibilityChanged(
  a: VisibilityState,
  b: VisibilityState
): boolean {
  return (
    a.pinLinksMenu !== b.pinLinksMenu ||
    a.shouldShowAccountSelectorInCenter !==
      b.shouldShowAccountSelectorInCenter ||
    a.shouldShowMobileMenu !== b.shouldShowMobileMenu ||
    a.shouldSearchBeAnIcon !== b.shouldSearchBeAnIcon ||
    a.shouldShowDealerCenterText !== b.shouldShowDealerCenterText ||
    a.shouldAccountSelectorBeAnIcon !== b.shouldAccountSelectorBeAnIcon ||
    a.showFooter !== b.showFooter ||
    a.shouldNavigationBeAnIcon !== b.shouldNavigationBeAnIcon
  );
}

export function calculateVisibility(
  windowDimensions: useWindowDimensionsInterface
): VisibilityState {
  return {
    shouldSearchBeAnIcon: !windowDimensions.isLgOrGreater,
    shouldAccountSelectorBeAnIcon: false,
    shouldShowMobileMenu: false,
    shouldShowAccountSelectorInCenter: windowDimensions.isMdOrGreater,
    showFooter: true,
    shouldNavigationBeAnIcon: !windowDimensions.isLgOrGreater,
    shouldShowDealerCenterText: windowDimensions.isMdOrGreater,
    pinLinksMenu: shouldPinLinksMenu(windowDimensions)
  };
}
